import { render, staticRenderFns } from "./to-receive.vue?vue&type=template&id=1d49137e&scoped=true"
import script from "./to-receive.vue?vue&type=script&lang=js"
export * from "./to-receive.vue?vue&type=script&lang=js"
import style0 from "./to-receive.vue?vue&type=style&index=0&id=1d49137e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d49137e",
  null
  
)

export default component.exports